import { LANGUAGES, type Language } from "@bt/domain";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { de } from "./de";
import { en } from "./en";

/** Each language in its own name. */
const LABELS: Record<Language, string> = { en: "English", de: "Deutsch" };

/** The app's languages (`LANGUAGES` in the domain) with their names, for pickers. */
export const LANGUAGE_OPTIONS = LANGUAGES.map((code) => ({ code, label: LABELS[code] }));

const STORAGE_KEY = "bt-language";

/** i18next's language ("de-DE", "en") as one of the app's languages. */
export function toLanguage(lng: string): Language {
  return lng.startsWith("de") ? "de" : "en";
}

function initialLanguage(): Language {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "en" || stored === "de") return stored;
  } catch {
    // Storage can be unavailable; fall back to the browser language.
  }
  return navigator.language.toLowerCase().startsWith("de") ? "de" : "en";
}

export function setLanguage(language: Language): void {
  try {
    localStorage.setItem(STORAGE_KEY, language);
  } catch {
    // Not persisted; the choice still applies to this session.
  }
  void i18n.changeLanguage(language);
}

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, de: { translation: de } },
  lng: initialLanguage(),
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnNull: false,
});

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});
document.documentElement.lang = i18n.language;

export default i18n;
